import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Courier from "./pages/Courier";
import Sourcing from "./pages/Sourcing";
import Pickup from "./pages/Pickup";
import Contact from "./pages/Contact";
import Track from "./pages/Track";
import Forms from "./pages/Forms";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import Quote from "./pages/Quote";
import ReceiptPrint from "./pages/ReceiptPrint";

function PublicLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/courier" element={<PublicLayout><Courier /></PublicLayout>} />
          <Route path="/sourcing" element={<PublicLayout><Sourcing /></PublicLayout>} />
          <Route path="/pickup" element={<PublicLayout><Pickup /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/quote" element={<PublicLayout><Quote /></PublicLayout>} />
          <Route path="/track" element={<PublicLayout><Track /></PublicLayout>} />
          <Route path="/forms" element={<PublicLayout><Forms /></PublicLayout>} />
          <Route path="/admin/login" element={<PublicLayout><Login /></PublicLayout>} />
          <Route path="/admin/receipts/:id/print" element={<ProtectedRoute><ReceiptPrint /></ProtectedRoute>} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
